import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import configProvider from "./configProvider";

const reactPlugin = new ReactPlugin();
const appInsights = configProvider.APPLICATIONINSIGHTS_CONNECTION_STRING
  ? new ApplicationInsights({
      config: {
        connectionString: configProvider.APPLICATIONINSIGHTS_CONNECTION_STRING,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history: createBrowserHistory() },
        },
        disableFetchTracking: false,
        enableCorsCorrelation: true,
        // Do not attach correlation headers to third parties -- it breaks their CORS.
        //
        // enableCorsCorrelation makes App Insights add Request-Id / traceparent to EVERY
        // cross-origin fetch, including ones we do not own. Mapbox's tile API does not list
        // request-id in Access-Control-Allow-Headers, so the preflight fails and the browser
        // blocks the tile outright:
        //
        //   Access to fetch at 'https://api.mapbox.com/v4/mapbox.satellite/...' has been blocked
        //   by CORS policy: Request header field request-id is not allowed by
        //   Access-Control-Allow-Headers in preflight response.
        //
        // That is what made Satellite View black for dispatchers. It hit satellite and not the
        // street basemap because vector tiles are fetched inside a Web Worker, which App Insights
        // does not instrument, while raster tiles are fetched on the main thread and so pick the
        // header up. And it only ever happened on a deployed environment, because this whole
        // block is skipped when there is no connection string -- i.e. everywhere local.
        //
        // This setting REPLACES the SDK's default list rather than adding to it, so the storage
        // domains it ships with are repeated here.
        correlationHeaderExcludedDomains: [
          "*.blob.core.windows.net",
          "*.blob.core.chinacloudapi.cn",
          "*.blob.core.cloudapi.de",
          "*.blob.core.usgovcloudapi.net",
          "*.mapbox.com",
        ],
      },
    })
  : null;
appInsights?.loadAppInsights();
export { reactPlugin, appInsights };
